<template>
    <nav aria-label="Page navigation" v-if="enabled">
      <ul class="pagination">
            <li class="page-item" :class="{ disabled: !showPrevious }">
                <a class="page-link" href="#" aria-label="First" v-on:click.stop.prevent="firstPage()">
                    <span aria-hidden="true">&lt;&lt;</span>
                    <span class="sr-only">First</span>
                </a>
            </li>
            <li class="page-item" :class="{ disabled: !showPrevious }">
                <a class="page-link" href="#" aria-label="Previous" v-on:click.stop.prevent="previousPage()">
                    <span aria-hidden="true">&lt;</span>
                    <span class="sr-only">Previous</span>
                </a>
            </li>

            <li class="page-item" v-for="(index, page) in pagination" :class="{ active: page.active }">
                <a class="page-link" href="#" v-on:click.stop.prevent="changePage(index)">{{ page.text }}</a>
            </li>

            <li class="page-item" :class="{ disabled: !showNext }">
                <a class="page-link" href="#" aria-label="Next" v-on:click.stop.prevent="nextPage()">
                    <span aria-hidden="true">&gt;</span>
                    <span class="sr-only">Next</span>
                </a>
            </li>
            <li class="page-item" :class="{ disabled: !showNext }">
                <a class="page-link" href="#" aria-label="Last" v-on:click.stop.prevent="lastPage()">
                    <span aria-hidden="true">&gt;&gt;</span>
                    <span class="sr-only">Last</span>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
  export default {
    props: [
      'records',
      'rowPerPage'
    ],
    data () {
      return {
        current: 1,
        previous: false,
        next: 2,
        first: 1,
        last: false,
        pages: [],
        pagination: []
      }
    },
    watch: {
      records: function () {
        this.current = 1
        this.prepare()
      },
      current: function () {
        this.prepare()
        this.$dispatch('change-page', this.current)
      },
      rowPerPage: function () {
        this.prepare()
        this.$dispatch('change-page', this.current)
      }
    },
    computed: {
      enabled: function () {
        return this.records.length > this.rowPerPage
      },
      showPrevious: function () {
        return this.current > 1
      },
      showNext: function () {
        return this.current < this.pages.length
      }
    },
    methods: {
      getNumberPages () {
        return Math.ceil(this.records.length / this.rowPerPage)
      },
      addPage (valeur) {
        this.pages.push({ text: valeur, active: this.current === valeur })
      },
      prepare () {
        this.pages = []
        let total = this.getNumberPages()
        for (let i = 1, l = total; i <= l; i++) {
          this.addPage(i)
        }
        this.last = this.pages.length - 1
        this.previous = (this.current > 0) ? this.current - 1 : false
        this.next = (this.current < this.pages.length) ? this.current + 1 : false

        let slice = (this.pages.length >= 10) ? 10 : this.pages.length
        let before = Math.ceil(slice / 2)
        let after = Math.floor(slice / 2)
        let start = 0
        if (this.current > before && (this.current + after) <= this.pages.length) {
          start = this.current - before
        } else if (this.current > 5) {
          start = this.pages.length - slice
        } else {
          start = 0
        }
        this.pagination = this.pages.slice(start, start + slice)
      },
      changePage (index) {
        this.current = this.pagination[index].text
      },
      lastPage () {
        this.current = this.pages.length
      },
      firstPage () {
        this.current = 1
      },
      previousPage () {
        this.current = (this.current > 1) ? --this.current : this.current
      },
      nextPage () {
        this.current = (this.current < this.pages.length) ? ++this.current : this.current
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// Pagination.vue?300d7ca2